// src/pages/creator-panel/CallLogs/utils/formatters.js
// Display helpers shared across the Call Logs list + detail views.

export const truncateId = (id, head = 4, tail = 4) => {
    if (!id) return '';
    const s = String(id);
    if (s.length <= head + tail + 3) return s;
    return `${s.slice(0, head)}...${s.slice(-tail)}`;
};

export const formatDuration = (totalSeconds) => {
    if (totalSeconds == null) return '—';
    const s = Math.max(0, Math.floor(totalSeconds));
    const m = Math.floor(s / 60);
    const ss = s % 60;
    if (m === 0) return `${ss}s`;
    return `${m}m ${ss.toString().padStart(2, '0')}s`;
};

export const formatCost = (n) => {
    if (n == null) return '$0.00';
    return `$${Number(n).toFixed(2)}`;
};

export const formatHeaderDate = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    const mm = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const yyyy = d.getFullYear();
    const hh = pad(d.getHours());
    const mi = pad(d.getMinutes());
    return `${mm}/${dd}/${yyyy} ${hh}:${mi}`;
};

export const formatLogTime = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    const monthShort = d.toLocaleString('en-US', { month: 'short' });
    const pad = (n) => String(n).padStart(2, '0');
    const ms = pad(d.getMilliseconds()).padStart(3, '0').slice(0, 3);
    return `${monthShort} ${d.getDate()}, ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${ms.padStart(3, '0')}`;
};

// Pill colors — tuned for adequate contrast on a light background.
// Backgrounds are tinted-alpha; foreground text uses the matching 700-shade.
export const categoryColor = (cat) => {
    const map = {
        Call:        { bg: 'rgba(100, 116, 139, 0.15)', fg: '#334155' }, // slate-700
        Transcriber: { bg: 'rgba(168, 85, 247, 0.15)',  fg: '#6b21a8' }, // purple-700
        Model:       { bg: 'rgba(99, 102, 241, 0.15)',  fg: '#3730a3' }, // indigo-700
        TTS:         { bg: 'rgba(20, 184, 166, 0.18)',  fg: '#0f766e' }, // teal-700
        Voice:       { bg: 'rgba(236, 72, 153, 0.15)',  fg: '#9d174d' }, // pink-700
    };
    return map[cat] || { bg: 'rgba(100, 116, 139, 0.12)', fg: '#475569' };
};

export const levelColor = (level) => {
    const l = String(level || '').toLowerCase();
    if (l === 'error') return { bg: 'rgba(239, 68, 68, 0.18)',  fg: '#b91c1c' }; // red-700
    if (l === 'warn' || l === 'warning') return { bg: 'rgba(245, 158, 11, 0.20)', fg: '#b45309' }; // amber-700
    return { bg: 'rgba(59, 130, 246, 0.18)', fg: '#1d4ed8' }; // blue-700 (Info)
};
